import Phaser from 'phaser';
import componentCoordinates from './ComponentCoordinates';
import DailyBonusSprite from '../classes/DailyBonusSprite';
import BonezButton from '../classes/BonezButton';
import { session, client } from '../../../../utils/nakama';
import eventsCenter, { PHASER_EVENTS } from '../../../../utils/phaserEvents';

let scale;
let coordinates
let screenWidth = window.outerWidth;
let screenHeight = window.outerHeight;

export default class DailyBigBonus extends Phaser.Scene {
    constructor() {
        super("DailyBigBonus");
        this.cardImage = null;
        // Variable to store the current power card name
        this.currentPowerCard = null;
        
    }

    init(data) {
        this.DailyRewardStatus = data.dailyRewardStatus;
    }

    preload() {
        if (screenWidth >= 1200) {
            scale = componentCoordinates.desktop.scale;
            coordinates = componentCoordinates.desktop.coordinates;
        }else{
            scale = componentCoordinates.mobile.scale;
            coordinates = componentCoordinates.mobile.coordinates;
        }

        //random select bonus sound
        // Array of power card names
        const bonusSounds = [
            "winbanjo",
            "winbrass",
            "windoot",
            "winfantasia",
            "winfretless",
        ];
        //Select random sound to load
        let soundFile = bonusSounds[Math.floor(Math.random() * bonusSounds.length)];
        //Load the sound
        this.load.audio('win-day-big-sound', '/bonez/sounds/' + soundFile + '.mp3');
    }

    create() {
        // Array for cards pulled to animate
        this.pulledCards = [];

        this.add.image(0, 0, 'bonus_images', 'daily_bonus_bg').setOrigin(0, 0).setScale(scale.DailyBonusBg);

        //Add particles behind the bag
        this.particles = this.add.particles(coordinates.other.particlesXP.x, coordinates.other.particlesXP.y,'xp',{
            scale: { start: 0.2, end: 0, random: true },
            rotate: { start: 0, end: 360 },
            speed: 200,
            lifespan: scale.particlesXPLifeSpan,
            gravityY: 0,
        });

        // Text for "Return every day for new Rewards!"
        this.add.text(coordinates.text.returnEveryDay.x, coordinates.text.returnEveryDay.y, 'Return every day', {
            font: '900 120px Truculenta',
            color: '#A7E73C',
        }).setScale(scale.returnEveryDay);

        this.add.text(coordinates.text.forNewRewards.x, coordinates.text.forNewRewards.y, 'for new Rewards!', {
            font: '900 120px Truculenta',
            color: '#A7E73C',
        }).setScale(scale.returnEveryDay);

        // Text for "NEXT REWARD IN:" initially hidden
        this.nextRewardText = this.add.text(coordinates.text.nextRewardIn.x, coordinates.text.nextRewardIn.y, 'NEXT REWARD IN:', {
            font: '900 100px Truculenta',
            color: 'white',
        }).setVisible(false);

        // Comments below "Add background" initially hidden
        this.txtFiveDayStreak = this.add.text(coordinates.text.fiveDayStreak.x, coordinates.text.fiveDayStreak.y, this.DailyRewardStatus.dailyCounter.toLocaleString()+'+ DAY STREAK!', {
            font: '900 200px Truculenta',
            color: '#9370DB',
            align: 'right',
        }).setVisible(true).setScale(scale.fiveDayStreak);

        this.txtSurpriseBag = this.add.text(coordinates.text.surpriseBag.x, coordinates.text.surpriseBag.y, 'SURPRISE BAG!', {
            font: '900 200px Truculenta',
            color: '#9370DB',
            align: 'right',
        }).setVisible(true).setScale(scale.fiveDayStreak);

        // Add Bag sprite
        this.day5 = new DailyBonusSprite(
            this,
            coordinates.other.dailyBonusSprite.x, // x position
            coordinates.other.dailyBonusSprite.y, // y position
            "day5", 
            scale.bonusSprite,
        );
        //animate the bag as a pulsing animation
        this.tweens.add({
            targets: this.day5,
            scale: 1.1,
            rotate: {min: -0.02, max: 0.02},
            duration: 2000,
            ease: 'Sine.easeInOut',
            yoyo: true,
            repeat: -1
        });

        // Add a button
        this.btnCollectReward = new BonezButton(this, coordinates.other.openBagButton.x, coordinates.other.openBagButton.y, 'OPEN BAG', () => {
            //call the collect reward function
            this.collectReward();
        }).setVisible(false).setScale(scale.openBagButton);

        // Initialize the scene state
        // Show button or time
        if (this.DailyRewardStatus.serverTime >= this.DailyRewardStatus.nextReward) {
            // Show the button
            this.btnCollectReward.setVisible(true);
        } else {
            // Show the timer
            this.startDayTimer();
        }
    }

    showReward() {
        //ensure text and bag are hidden
        this.nextRewardText.setVisible(false);
        this.txtFiveDayStreak.setVisible(false);
        this.txtSurpriseBag.setVisible(false);
        this.day5.setVisible(false);

        // Prepare the payload reward
        // Array of power card names
        const powerCardNames = [
            "1_or_11",
            "double",
            "redraw",
            "resurrect",
            "steal",
            "tie_breaker",
            "day4",
        ];

        //process the payload
        //sort least to most
        this.DailyRewardStatus.reward = Object.fromEntries(
            Object.entries(this.DailyRewardStatus.reward)
            .sort((a, b) => a[1] - b[1])
        );
        
        //loop through the payload and show the rewards
        let counter = 1;
        let bonezTotal = 0;

        //Always show + sign as the center of layout
        this.add.text(
            coordinates.other.fiveDayPlusSign.x,
            coordinates.other.fiveDayPlusSign.y,
            '+', {
            font: '900 400px Truculenta',
            color: '#A7E73C',
        });

        for (const [key,value] of Object.entries(this.DailyRewardStatus.reward)) {

            //If Bonez, show the bonez pile
            if(key.startsWith("bonez_")){
                bonezTotal += parseInt(key.split("_")[1]);
            }else{
                //else show the card

               new DailyBonusSprite(
                    this,
                    coordinates.other.fiveDayPlusSign.x + counter*500, // x position
                    coordinates.other.dailyBonusSprite.y, // y position
                    key,
                    scale.bonusSprite,
                ).setVisible(true).showCheckMark(true);
                
                //If value == 2, show X2
                if(value > 1){
                    this.add.text(
                        coordinates.other.fiveDayPlusSign.x + counter*500 + 200,
                        coordinates.other.dailyBonusSprite.y,
                        'X2' + value, {
                        font: '900 400px Truculenta',
                        color: '#A7E73C',
                    });
                }
                counter++;
            }
        }
        // this.animateCard();

        //The bonez total once 
        if(bonezTotal > 0){

            new DailyBonusSprite(
                this,
                coordinates.other.fiveDayPlusSign.x - scale.fiveDayBonezSpriteOffset, // x position
                coordinates.other.dailyBonusSprite.y, // y position
                "day4", //Full bag of bones
                scale.bonusSprite,
            ).setVisible(true).showCheckMark(true)

            // add a label for the bonez total
            this.add.text(
                coordinates.other.fiveDayPlusSign.x - coordinates.text.bonezFiveDayTextOffset.x,
                coordinates.other.dailyBonusSprite.y + coordinates.text.bonezFiveDayTextOffset.y,
                bonezTotal + ' BONEZ', {
                font: '900 120px Truculenta',
                color: '#A7E73C',
            }).setScale(scale.dailyRewardDayLabel);
            
            //Show bonez animation
            for(let i = 0; i < bonezTotal/15; i++){
                this.showBonezAnimation();
            }
        }
    }

    // animateCard() {
    //     console.log("Animating card", this.pulledCards);
    //     this.tweens.add({
    //         targets: this.pulledCards, 
    //         angle: 360,
    //         x: (Math.random() * 400) + 1000,
    //         y: Math.random() * 400,
    //         scale: Math.random() * 0.3,
    //         delay: (Math.random() * 500) + 1000,
    //         duration: (Math.random() * 500) + 200,
    //         ease: 'Linear',
    //         repeat: 0,
    //         onComplete: () => {
    //             this.pulledCards.destroy();
    //         }
    //     });
    // }

    startDayTimer() {
        // Start a 24-hour timer
        //let duration = 86400000; // 24 hours in milliseconds
        let duration = this.DailyRewardStatus.nextReward - this.DailyRewardStatus.serverTime; // 24 hours in milliseconds
        let endTime = this.DailyRewardStatus.serverTime + duration;
    
        this.time.addEvent({
            delay: 1000,
            callback: () => {
                let remaining = endTime - Date.now();
                if (remaining < 0) {
                    // When the timer ends, show the button again
                    this.time.removeAllEvents();
                    this.btnCollectReward.show();
                    if (this.timerText) {
                        this.nextRewardText.setVisible(false);
                        this.timerText.setVisible(false);
                    }
                } else {
                    // Update the timer text
                    if (!this.timerText) {
                        // Text for "NEXT REWARD IN:" initially hidden
                        this.nextRewardText = this.add.text(coordinates.text.nextRewardIn.x, coordinates.text.nextRewardCounter.y, 'NEXT REWARD IN:', {
                            font: '900 100px Truculenta',
                            color: 'white',
                        });
                        this.timerText = this.add.text(coordinates.text.nextRewardCounter.x, coordinates.text.nextRewardCounter.y, '', {
                            font: '900 100px Truculenta',
                            color: '#A7E73C'
                        });
                    } else if (!this.timerText.visible) {
                        this.nextRewardText.setVisible(true);
                        this.timerText.setVisible(true);
                    }
                    this.timerText.setText(this.formatTime(remaining));
                }
            },
            callbackScope: this,
            loop: true
        });
    }
    
    formatTime(milliseconds) {
        let seconds = Math.floor((milliseconds / 1000) % 60);
        let minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
        let hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
    
        return hours + ":" + minutes + ":" + seconds;
    }

    showBonezAnimation() {
        //Add Bonez animation
        let bone = this.add.sprite(coordinates.other.openBagButton.x, coordinates.other.openBagButton.y, 'bone').setScale(1);
        this.tweens.add({
            targets: bone, 
            angle: 360,
            x: Math.random() * 400,
            y: Math.random() * 400,
            scale: Math.random() * 0.3,
            duration: (Math.random() * 500) + 200,
            ease: 'Linear',
            repeat: 0,
            onComplete: () => {
                bone.destroy();
            }
        });
    }

    async collectReward() {
        //call the collect reward function
        this.btnCollectReward.setVisible(false);
        //TODO - Show spinner
        // Call RPC to collect reward    
        const res = await client.rpc(session, "checkdailyreward", {"request": "collectReward"});
        this.DailyRewardStatus = await res.payload;
        this.startDayTimer();
        eventsCenter.emit(PHASER_EVENTS.REWARD_COLLECTED, this.DailyRewardStatus);
        // Update the scene state
        this.showReward();
        //TODO - Play collect sound and show animation
        //this.sound.play('win-day' + Phaser.Math.Between(2, 6));
        this.sound.play('win-day-big-sound');
    }
}
